
class Nonce {
  getNonce() {
    return {
      nonce: window.start.trackingId,
    };
  }
}

export default new Nonce();
